const ErrorCode = {
    // common
    OK: 0,
    UNKNOWN: 1,
    INVALID_PARAM: 2,

    // auth (100–199)
    AUTH_UNAUTHORIZED: 100,
    AUTH_SERVER_MAINTENANCE: 101,
    AUTH_NOT_VERIFIED: 102,
    AUTH_BANNED_USER: 103,
    AUTH_INACTIVE_USER: 104,
    AUTH_SERVICE_NOT_REGISTERED: 105,
    AUTH_INSUFFICIENT_PERMISSION: 106,
    AUTH_USERNAME_NOT_REGISTERED: 107,

    // signup (200–299)
    SIGNUP_EMAIL_EXISTS: 200,
    SIGNUP_USERNAME_EXISTS: 201,
    SIGNUP_AGE_RESTRICTED: 202,
    SIGNUP_USERNAME_INVALID: 203,
    SIGNUP_USERNAME_BLOCKED: 204,

    // login (300–349)
    LOGIN_INVALID_EMAIL_OR_PASSWORD: 300,
    LOGIN_BLOCKED_USER: 301,
    LOGIN_INACTIVE_USER: 302,
    LOGIN_RATE_LIMITED: 303,
    LOGIN_MFA_REQUIRED: 304,

    // mfa (350–399)
    MFA_INVALID_CODE: 350,
    MFA_ALREADY_ENABLED: 351,
    MFA_NOT_ENABLED: 352,
    MFA_SETUP_REQUIRED: 353,

    // logout (400–449)
    LOGOUT_ALREADY: 400,

    // user (500–599)
    USER_ALREADY_FOLLOWED: 500,
    USER_ALREADY_UNFOLLOWED: 501,
    USER_MAX_FOLLOWING: 502,
    USER_PROFILE_NOT_UPDATED: 503,
    USER_INVALID_USER: 504,
    USER_PROFILE_IMAGE_REJECTED: 505,
    USER_ALREADY_FAVORITED: 506,
    USER_ALREADY_UNFAVORITED: 507,
    USER_MAX_FAVORITE: 508,
    USER_NOT_FRIENDS: 509,

    // content (600–699)
    RESTRICTION: 600,
    COMMENT_MAX_DEPTH: 601,
    NOTICE: 602,
    REPORT_ALREADY_PENDING: 603,
    FEATURE_DISABLED: 604,

    // admin (1000–1099)
    ADMIN_UNKNOWN_CONFIG: 1000,
    ADMIN_UNKNOWN_COMMAND: 1001,
    ADMIN_UNKNOWN_COMMAND_ARGS: 1002,
    ADMIN_FILTER_OPTION_IN_USE: 1003,
};

export { ErrorCode };
